String.prototype.capitalise = function () {
    return this[0].toUpperCase() + this.substring(1, this.length).toLowerCase()
};
